import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05785b95")

_pushScopeId("data-v-05785b95")
const _hoisted_1 = { class: "CompletedDelivery" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "CompletedDelivery__header" }, [
  /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "О доставке")
], -1)
const _hoisted_3 = { class: "CompletedDelivery__body" }
const _hoisted_4 = { class: "body__row" }
const _hoisted_5 = { class: "body__col" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Сторона оплаты", -1)
const _hoisted_7 = { class: "col__text" }
const _hoisted_8 = { class: "body__col" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Способ оплаты", -1)
const _hoisted_10 = { class: "col__text" }
const _hoisted_11 = { class: "body__row" }
const _hoisted_12 = { class: "body__col" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Наложенный платёж", -1)
const _hoisted_14 = { class: "col__text" }
const _hoisted_15 = { class: "body__col" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Тип доставки", -1)
const _hoisted_17 = { class: "col__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.delivery.paymentType.name), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("p", _hoisted_10, _toDisplayString(_ctx.delivery.paymentMethod.name), 1)
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("p", _hoisted_14, _toDisplayString(_ctx.delivery.codPayment) + " тг.", 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("p", _hoisted_17, _toDisplayString(_ctx.delivery.shipmentType.name), 1)
        ])
      ])
    ])
  ]))
})